import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "src/components/layout"
import SEO from "src/components/seo"
import Img from "gatsby-image"


class IndexPost extends React.Component {

  render() {

    const { data } = this.props;
    //console.log(data);
    console.log(`ALL DATA:`, data)

    return (
      <React.Fragment>
          <div className="recentYouTubeVideos">
          {data.data.ChoflyEliteRaidYouTubeVideos ?
            <>
            <h2>My Recent <b>Raid: Shadow Legends</b> Videos</h2>
            <div className="videos-wrap">
              {data.data.ChoflyEliteRaidYouTubeVideos.edges.map(items => (
                <iframe key={items} src={`https://www.youtube-nocookie.com/embed/${items.node.videoId}`} title={items.node.title} alt={items.node.title} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              ))}
            </div>
            <a className="btn btnGreen moveUp" href="https://www.youtube.com/channel/UCDClIEc8CVfPz8nA8lVHiQQ" rel="noopener noreferrer">View More</a>
            </>
          :
            <div className="hidden"></div>
          }


          {data.data.OfficialRaidYouTubeVideos ?
            <>
            <h2>Recent Offical <b>Raid: Shadow Legends</b> Videos</h2>
            <div className="videos-wrap">
              {data.data.OfficialRaidYouTubeVideos.edges.map(items => (
                <iframe key={items} src={`https://www.youtube-nocookie.com/embed/${items.node.videoId}`} title={items.node.title} alt={items.node.title} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              ))}
            </div>
            <a className="btn btnGreen moveUp" href="https://www.youtube.com/channel/UCVME1RlhWxfoZ2ZcGWlz_KA" rel="noopener noreferrer">View More</a>
            </>
          :
            <div className="hidden"></div>
          }
        </div>
      </React.Fragment>
    );
  }
}

const IndexPage = data => (

  <Layout>
    <SEO
    title="Chofly Elite - Raid: Shadow Legends"
    ogTitle="Chofly Elite - Raid: Shadow Legends"
    ogURL="https://choflyelite-legacy.netlify.com"
    ogDescription="Chofly Elite / Raid: Shadow Legends | Gaming Content Producer | Currently focussed on RAID Shadow Legends | Plarium Moderator | Twitch Streamer | YouTube Content Creator | Chofly Elite Community Discord"
    ogImage={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    ogImageSecure={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    keywords={['Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />
    <div className="container">
      <div className="container-content-wrap">
        <br />
        <div className="text-center"><h1 className="with-underline">Raid: Shadow Legends</h1></div>

        <Link className="btn btnGreen" to="/raid/tier-list" rel="noopener noreferrer">View My Tier List</Link>
        <br /><br />

        <div className="category-page-wrap raid">
          <section>
            <h2><a href="https://plarium.com/landings/en/desktop/raid/dragon_fire_f038_fdb_droapp?plid=150483&pxl=google_search&publisherid=raid%20shadow%20legends%20online_kwd-764879449434_118125236868&placement=467215100085_118125236868&adpartnerset=118125236868&gclid=CjwKCAjw2P-KBhByEiwADBYWCpdKMCgukmTi-yhQTSXl548E3hAH9BOzBikiugiLpcNDoA3XHEgqqxoCa_sQAvD_BwE" target="_blank" rel="noopener noreferrer" alt="Cick to view Raid: Shadow Legends's Offical Website in new tab" title="Cick to view Raid: Shadow Legends's Offical Website in new tab">Offical Website</a> | <a href="https://plarium.com/forum/en/raid-shadow-legends/828_en/" target="_blank" rel="noopener noreferrer" alt="Cick to view Raid: Shadow Legends's Offical Forum in new tab" title="Cick to view Raid: Shadow Legends's Offical Website in new tab">Offical Forum</a></h2>

{/*             <h3 className="with-underline">Guides & Resources</h3>
            <p className="guides-list">
                <div>
                  <a href="https://www.raid101.com/" target="_blank" rel="noopener noreferrer" alt="Community Wiki" title="Community Wiki">Raid 101</a>
                </div>
                <div>
                  <a href="https://raidofcreation.wiki/" target="_blank" rel="noopener noreferrer" alt="Community Wiki" title="Community Wiki">Community Wiki</a>
                </div>
                <div>
                  <a href="https://verracaravan.com/" target="_blank" rel="noopener noreferrer" alt="Verra Caravan - Your Raid: Shadow Legends Resource" title="Verra Caravan - Your Raid: Shadow Legends Resource">Verra Caravan - Your Raid: Shadow Legends Resource</a>
                </div>
                <div>
                  <a href="https://www.hellhades.com/introduction-to-the-4-nodes-in-raid-of-creation/" target="_blank" rel="noopener noreferrer" alt="HellHades: Introduction to the 4 Nodes in Raid: Shadow Legends" title="HellHades: Introduction to the 4 Nodes in Raid: Shadow Legends">HellHades: Introduction to the 4 Nodes in Raid: Shadow Legends</a>
                </div>
                <div>
                  <a href="https://www.mmorpg.com/raid-of-creation/articles" target="_blank" rel="noopener noreferrer" alt="MMORPG Articles" title="MMORPG Articles">MMORPG Articles</a>
                </div>
            </p> */}
          </section>
          <br />
          <IndexPost data={data} />
{/*          <h2>Lorem ipsum dolor</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis. Mi eget mauris pharetra et ultrices neque. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis. Mi eget mauris pharetra et ultrices neque.</p>*/}
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage



export const query = graphql`
  query RaidPageQuery {


      home {
        heading
        content
        featured_image {
          id
          fileName
          extension
        }
        game_logos {
          extension
          fileName
          url
          size
          id
          height
          width
          type
        }
        game_logo_width
        game_logo_margin
      }


      OfficialRaidYouTubeVideos: allYoutubeVideo (
        sort: {order: DESC, fields: publishedAt},
        filter: {
          channelId: {eq: "UCVME1RlhWxfoZ2ZcGWlz_KA"},
        }
      ) {
        edges {
          node {
            id
            title
            videoId
            description
            thumbnail {
              url
              height
              width
            }
            channelId
            channelTitle
            publishedAt
            privacyStatus
          }
        }
      }

      ChoflyEliteRaidYouTubeVideos: allYoutubeVideo (
        sort: {order: DESC, fields: publishedAt},
        filter: {
          channelId: {eq: "UCDClIEc8CVfPz8nA8lVHiQQ"},
          title: {regex: "/.*RAID Shadow Legends/"}
        }
      ) {
        edges {
          node {
            id
            title
            videoId
            description
            thumbnail {
              url
              height
              width
            }
            channelId
            channelTitle
            publishedAt
            privacyStatus
          }
        }
      }


  }
`





